import {Component, Inject, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../../core/services/auth.service';

@Component({
  selector: 'mes-login-email-password',
  templateUrl: './email-password.component.html'
})
export class EmailPasswordComponent implements OnInit {
  password: string;
  email: string;
  private returnUrl: string;

  constructor(private router: Router, private authService: AuthService, @Inject('BASE_URL') public baseUrl: string, private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  loginWithPassword() {
    this.authService.login(this.email, this.password, this.returnUrl).subscribe();
  }
}
